var CGI = (function ($) {

    function init() {

    }

    jQuery(document).ready(function () {
        jQuery('.main-navigation ul.menu > li > .sub-menu .sub-menu').each(function () {
            const el = jQuery(this);
            if (el.find('li').length > 6) {
                el.parents('li').addClass('has-columns');
            }
        })
    })

    jQuery('.main-navigation ul.menu > li').hoverIntent({
        over: navover,
        out: navout,
        timeout: 100,
        interval: 10
    });
    // (how to use both fade and slide effects!):
    function navover() {
        jQuery(this).addClass('hover')
        jQuery(this).children('.sub-menu')
            .show();
    }
    function navout() {
        jQuery(this).removeClass('hover');
        jQuery(this).children('.sub-menu')
            .hide();
    }

    jQuery(document).on('click', '.open-arrow', function (e) {
        e.preventDefault();
        jQuery(this).parent().parent().toggleClass('open');
        return false;
    });

    jQuery(document).on('click', '.mobile-menu-list .menu-item-has-children > a', function (e) {
        e.preventDefault();
        const menuItem = jQuery(this).parent('li');
        menuItem.toggleClass('menu-open');
        return false;
    });

    function calcSliderPos(e) {
        return (e.offsetX / e.target.clientWidth) * parseInt(e.target.getAttribute('max'), 10);
    }

    function beforeAfter(element, b) {
        const valueHover = calcSliderPos(element).toFixed(2);
        b.value = valueHover;
        b.previousElementSibling.style.width = valueHover + "%";
    }

    window.beforeAfter = beforeAfter;

    function before() {
        $(".before-after").twentytwenty({
            move_slider_on_hover: true,
            no_overlay: true,
            // orientation: 'vertical',
            // before_label: 'Было',
            // after_label: 'Стало',
        });
    }

    setTimeout(before, 1000);

    // On click on the button set cookie "grb-cookie-consent" to yes for 1 week
    jQuery('.cookie-consent-button').click(function () {
        jQuery.cookie('grb-cookie-consent', 'yes', {
            expires: 7,
            path: '/'
        });
        jQuery('.grb-cookie-consent').hide();
    }
    );

    jQuery(document).on('click', '.job-apply-button', function () {
        const jobId = jQuery(this).data('job-id');
        const modal = jQuery('#modal-' + jobId);
        modal.fadeIn(300);
        jQuery('body').addClass('modal-open');
    });

    jQuery(document).on('click', '.job-modal-close, .job-modal-overlay', function () {
        jQuery(this).closest('.job-modal').fadeOut(300);
        jQuery('body').removeClass('modal-open');
    });

    jQuery(document).on('change', 'input[type="file"][name="applicant_cv"]', function () {
        const fileName = jQuery(this).val().split('\\').pop();
        const fileNameDisplay = jQuery(this).closest('.file-upload-group').find('.file-name');
        if (fileName) {
            fileNameDisplay.text(fileName);
        } else {
            fileNameDisplay.text('');
        }
    });

    jQuery(document).on('submit', '.job-application-form', function (e) {
        e.preventDefault();

        const form = jQuery(this);
        const submitButton = form.find('.job-submit-button');
        const originalText = submitButton.text();
        const jobTitle = form.data('job-title');
        const formData = new FormData(this);
        formData.append('action', 'submit_job_application');
        formData.append('job_title', jobTitle);

        submitButton.prop('disabled', true).text('Se trimite...');

        jQuery.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                if (response.success) {
                    alert('Aplicația dvs. a fost trimisă cu succes!');
                    form[0].reset();
                    form.find('.file-name').text('');
                    form.closest('.job-modal').fadeOut(300);
                    jQuery('body').removeClass('modal-open');
                } else {
                    alert(response.data.message || 'A apărut o eroare. Vă rugăm să încercați din nou.');
                }
                submitButton.prop('disabled', false).text(originalText);
            },
            error: function () {
                alert('A apărut o eroare. Vă rugăm să încercați din nou.');
                submitButton.prop('disabled', false).text(originalText);
            }
        });
    });


})(jQuery);

(function ($) {

    $.fn.twentytwenty = function (options) {
        var options = $.extend({
            default_offset_pct: 0.5,
            orientation: 'horizontal',
            before_label: 'Before',
            after_label: 'After',
            no_overlay: false,
            move_slider_on_hover: false,
            move_with_handle_only: true,
            click_to_move: false
        }, options);

        return this.each(function () {

            var sliderPct = options.default_offset_pct;
            var container = $(this);
            var sliderOrientation = options.orientation;
            var beforeDirection = (sliderOrientation === 'vertical') ? 'down' : 'left';
            var afterDirection = (sliderOrientation === 'vertical') ? 'up' : 'right';


            container.wrap("<div class='twentytwenty-wrapper twentytwenty-" + sliderOrientation + "'></div>");
            if (!options.no_overlay) {
                container.append("<div class='twentytwenty-overlay'></div>");
                var overlay = container.find(".twentytwenty-overlay");
                overlay.append("<div class='twentytwenty-before-label' data-content='" + options.before_label + "'></div>");
                overlay.append("<div class='twentytwenty-after-label' data-content='" + options.after_label + "'></div>");
            }
            var beforeImg = container.find("img:first");
            var afterImg = container.find("img:last");
            container.append("<div class='twentytwenty-handle'></div>");
            var slider = container.find(".twentytwenty-handle");
            slider.append("<span class='twentytwenty-" + beforeDirection + "-arrow'></span>");
            slider.append("<span class='twentytwenty-" + afterDirection + "-arrow'></span>");
            container.addClass("twentytwenty-container");
            beforeImg.addClass("twentytwenty-before");
            afterImg.addClass("twentytwenty-after");

            var calcOffset = function (dimensionPct) {
                var w = beforeImg.width();
                var h = beforeImg.height();
                return {
                    w: w + "px",
                    h: h + "px",
                    cw: (dimensionPct * w) + "px",
                    ch: (dimensionPct * h) + "px"
                };
            };

            var adjustContainer = function (offset) {
                if (sliderOrientation === 'vertical') {
                    beforeImg.css("clip", "rect(0," + offset.w + "," + offset.ch + ",0)");
                    afterImg.css("clip", "rect(" + offset.ch + "," + offset.w + "," + offset.h + ",0)");
                }
                else {
                    beforeImg.css("clip", "rect(0," + offset.cw + "," + offset.h + ",0)");
                    afterImg.css("clip", "rect(0," + offset.w + "," + offset.h + "," + offset.cw + ")");
                }
                container.css("height", offset.h);
            };

            var adjustSlider = function (pct) {
                var offset = calcOffset(pct);
                slider.css((sliderOrientation === "vertical") ? "top" : "left", (sliderOrientation === "vertical") ? offset.ch : offset.cw);
                adjustContainer(offset);
            };

            // Return the number specified or the min/max number if it outside the range given.
            var minMaxNumber = function (num, min, max) {
                return Math.max(min, Math.min(max, num));
            };

            // Calculate the slider percentage based on the position.
            var getSliderPercentage = function (positionX, positionY) {
                var sliderPercentage = (sliderOrientation === 'vertical') ?
                    (positionY - offsetY) / imgHeight :
                    (positionX - offsetX) / imgWidth;

                return minMaxNumber(sliderPercentage, 0, 1);
            };


            $(window).on("resize.twentytwenty", function (e) {
                adjustSlider(sliderPct);
            });

            var offsetX = 0;
            var offsetY = 0;
            var imgWidth = 0;
            var imgHeight = 0;
            var onMoveStart = function (e) {
                if (((e.distX > e.distY && e.distX < -e.distY) || (e.distX < e.distY && e.distX > -e.distY)) && sliderOrientation !== 'vertical') {
                    e.preventDefault();
                }
                else if (((e.distX < e.distY && e.distX < -e.distY) || (e.distX > e.distY && e.distX > -e.distY)) && sliderOrientation === 'vertical') {
                    e.preventDefault();
                }
                container.addClass("active");
                offsetX = container.offset().left;
                offsetY = container.offset().top;
                imgWidth = beforeImg.width();
                imgHeight = beforeImg.height();
            };
            var onMove = function (e) {
                if (container.hasClass("active")) {
                    sliderPct = getSliderPercentage(e.pageX, e.pageY);
                    adjustSlider(sliderPct);
                }
            };
            var onMoveEnd = function () {
                container.removeClass("active");
            };

            var moveTarget = options.move_with_handle_only ? slider : container;
            moveTarget.on("movestart", onMoveStart);
            moveTarget.on("move", onMove);
            moveTarget.on("moveend", onMoveEnd);

            if (options.move_slider_on_hover) {
                container.on("mouseenter", onMoveStart);
                container.on("mousemove", onMove);
                container.on("mouseleave", onMoveEnd);
            }

            slider.on("touchmove", function (e) {
                e.preventDefault();
            });

            container.find("img").on("mousedown", function (event) {
                event.preventDefault();
            });

            if (options.click_to_move) {
                container.on('click', function (e) {
                    offsetX = container.offset().left;
                    offsetY = container.offset().top;
                    imgWidth = beforeImg.width();
                    imgHeight = beforeImg.height();

                    sliderPct = getSliderPercentage(e.pageX, e.pageY);
                    adjustSlider(sliderPct);
                });
            }

            $(window).trigger("resize.twentytwenty");
        });
    };

})(jQuery);

// Subtle scroll animation for truck image
(function() {
    const truckImage = document.querySelector('.floater-truck-image');

    if (truckImage) {
        function updateTruckPosition() {
            const scrollY = window.scrollY;
            const maxScroll = 500;
            const maxMove = 50; // pixels to move

            const progress = Math.min(scrollY / maxScroll, 1);
            const translateX = progress * maxMove;

            truckImage.style.transform = 'translateX(' + translateX + 'px)';
            truckImage.style.opacity = '1';
        }

        // Wait for the load animation to complete (0.2s delay + 0.8s duration = 1s)
        setTimeout(function() {
            truckImage.style.animation = 'none'; // Remove CSS animation to allow JS control
            updateTruckPosition();
            window.addEventListener('scroll', updateTruckPosition);
        }, 1000);
    }
})();
